import React, { useEffect, useMemo } from 'react';
import UserUsageReportForm from './UserUsageReportForm/UserUsageReportForm';
import UserUsageReportResult from './UserUsageReportResult/UserUsageReportResult';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from 'store';
import { Spin } from 'antd';
import { ReducerNames } from 'common';
import { USER_USAGE_REPORT_FORM } from './UserUsageReport.constants';
import {
  getCustomers as getCustomersAction,
  customersSelector,
  userUsageReportAccessFlagSelector,
} from '.';
import { loadingSelector } from 'common';
import { getFormValues } from 'redux-form';
import { Redirect } from 'react-router-dom';
import { useAccount, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { getAccessToken } from 'common/helpers';

const UserUsageReport: React.FC = () => {
  const dispatch = useDispatch();

  const { loading, formValues, customers, accessFlag, userUsageReport } =
    useSelector((state: AppState) => ({
      loading: loadingSelector(ReducerNames.USER_USAGE_REPORT)(state),
      formValues: getFormValues(USER_USAGE_REPORT_FORM)(state),
      customers: customersSelector(state),
      accessFlag: userUsageReportAccessFlagSelector(state),
      userUsageReport: state.userUsageReport,
    }));

  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});

  useEffect(() => {
    if (
      account &&
      inProgress === InteractionStatus.None &&
      !customers &&
      accessFlag
    ) {
      getAccessToken(instance, account, inProgress).then((response) => {
        if (response?.accessToken)
          dispatch(getCustomersAction(response.accessToken));
      });
    }
  }, [dispatch, instance, account, inProgress, customers, accessFlag]);

  const spinnerTitle = useMemo((): string => {
    if (loading) return 'Searching data...';
    return '';
  }, [loading]);

  // explicit check for accessFlag === false because we don't want to redirect yet if the flag is null
  // null flag means it's still loading from the API
  if (accessFlag === false) {
    return <Redirect to={`/pages/dashboard`} />;
  }

  return (
    <Spin
      spinning={loading || !customers || !accessFlag}
      size="large"
      tip={spinnerTitle}
    >
      <UserUsageReportForm
        {...{
          loading,
          customers,
          formValues,
        }}
      />

      {userUsageReport.reports && (
        <UserUsageReportResult
          reports={userUsageReport.reports}
          searchCriteria={userUsageReport.searchCriteria}
        />
      )}
    </Spin>
  );
};

export default UserUsageReport;
